import { memo, useCallback } from 'react';
import { Eye } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useBlindStore } from '../../store/blind-store';
import { vibrate } from '../../utils/vibration';
import { log } from '../../utils/logger';
import './BlindPeekButton.css';

/**
 * «Sbircia»: rivela la scacchiera per un istante in una partita alla cieca.
 *
 * Sta AL POSTO di Focus nella barra dei comandi (lo slot `focusSlot`, lo stesso che usa il
 * boost d'arena) e non accanto: la barra regge quattro posti a 360px, e un quinto manderebbe
 * le etichette a capo. Il posto giusto è proprio quello, anche nel merito — Focus nasconde
 * la lista mosse, che alla cieca è l'unica cosa a cui ci si può appoggiare.
 *
 * Il conteggio si vede mentre si gioca, e non solo alla fine: sapere di essere alla terza
 * sbirciata è ciò che rende la quarta una scelta invece che un riflesso.
 */
export const BlindPeekButton = memo(function BlindPeekButton() {
  const { t } = useTranslation();
  const peek = useBlindStore((s) => s.peek);
  const peekCount = useBlindStore((s) => s.peekCount);
  const peekUntilMs = useBlindStore((s) => s.peekUntilMs);
  const isPeeking = peekUntilMs !== null;

  const handleClick = useCallback(() => {
    if (isPeeking) return;
    vibrate(30);
    log.info('BlindPeekButton', 'Peek requested');
    peek();
  }, [isPeeking, peek]);

  return (
    <button
      type="button"
      className={`game-toolbar__btn game-toolbar__btn--peek${isPeeking ? ' game-toolbar__btn--peek-active' : ''}`}
      data-testid="toolbar-peek"
      data-peek-count={peekCount}
      onClick={handleClick}
      disabled={isPeeking}
      title={t('game.actions.peek')}
    >
      <Eye size={20} aria-hidden="true" />
      <span>
        {t('game.actions.peek')}
        {peekCount > 0 && <span className="game-toolbar__peek-count"> {peekCount}</span>}
      </span>
    </button>
  );
});

export default BlindPeekButton;
